import { createContext } from "react";

import makeIacTableStore from "./components/Table/useIacTableStore/makeIacTableStore";

type IacManagementTableStoreContextValue = ReturnType<typeof makeIacTableStore>;

export const IacManagementTableStoreContext = createContext<
  IacManagementTableStoreContextValue | undefined
>(undefined);
